import React from "react";
import Typography from "@mui/material/Typography";
import { createTypography } from "src/theme/base/customTypography";
import * as SldSurveyCard from "src/theme/base/SldSurveyCard";
import Stack from "@mui/material/Stack";


function MTPSurveyTile() {
  const cardComponents = [
    {
      image: "/assets/Survey-Graphics/MTP-1.svg",
      text: "Create high trust, aligned, unified and engaged teams",
    },
    {
      image: "/assets/Survey-Graphics/MTP-2.svg",
      text: "Help foster a positive organisational culture built on trust, safety, and collaboration",
    },
    {
      image: "/assets/Survey-Graphics/MTP-3.svg",
      text: "Provide regular insights into key team success factors to help cocreate empowered workplaces",
    },
  ];

  const typography = createTypography();
  return (
    <Stack
    spacing={5}
    justifyContent="center"
    direction={{lg:'row',md:'column', sm:'column', xs:'column'}}
    >
 {cardComponents.map((item) => (
      <SldSurveyCard.SurveyCardStyle
        key={item.text}
        sx={{ width: {xs:'300px',sm:'350px',lg:'30%'} }}
      >
         
          {item.image ? (
            <SldSurveyCard.SurveyCardMedia

            >
              <img
                src={item.image}  
                alt={item.text}
                style={{ width: "100%", height: "100%", objectFit: "contain" }}
              />
            </SldSurveyCard.SurveyCardMedia>

          ) : (
            <SldSurveyCard.SurveyCardMedia
            style={{ height: 238 }} />
          )}

          <SldSurveyCard.SurveyCardContent
            
          >
          <Typography sx={{ ...typography.cardContent, textAlign: "center" ,fontSize:{xl:'18px',lg:'15px', md:'14px',sm:'14px', xs:'13px'}}}>
              {item.text}
            </Typography>
            </SldSurveyCard.SurveyCardContent>
      </SldSurveyCard.SurveyCardStyle>
      ))}
    </Stack>
  );
}

export default MTPSurveyTile;
